import Vue from 'vue'


import { clearLoginInfo } from '../tools'
export default [



  // 后台
  {
    path: '/admin',
    name:'admin',
    component: () => import('../views/admin/Home.vue'),
    children: [
      {
        path: "",
        redirect: "index"
        // redirect: to=>{
        //   console.log(Vue.cookie.get('token'))
        //   if (Vue.cookie.get('token')){
        //     return 'index'
        //   }else{
        //     return 'login'
        //   }
        // }
      },
      {
        path: 'index',
        name: 'adminIndex',
        component: () => import('../views/admin/index/Index.vue'),
        meta: { title: '首页' }
      },
      // 文字管理
      {
        path: 'article_list',
        name: 'article_list',
        component: () => import('../views/admin/article/List.vue'),
        meta: { title: '文章管理' }
      },
      {
        path: 'article_add',
        name: 'article_add',
        component: () => import('../views/admin/article/Add.vue'),
        meta: { title: '添加文章' }
      },
      // 渠道管理
      {
        path: 'channel',
        name: 'channel',
        component: () => import('../views/admin/channel/List.vue'),
        meta: { title: '渠道管理' }
      },
      // 客户信息
      {
        path: 'customer',
        name: 'customer',
        component: () => import('../views/admin/customer/Customer.vue'),
        meta: { title: '客户信息' }
      },
      //  (友情链接/合作伙伴)
      {
        path: 'friendlyLink',
        name: 'friendlyLink',
        component: () => import('../views/admin/friendlyLink/FriendlyLink.vue'),
        meta: { title: '友情链接/合作伙伴' }
      },

      // 近期活动
      {
        path: 'activity',
        name: 'activity',
        component: () => import('../views/admin/activity/Activity.vue'),
        meta: { title: '近期活动' }
      },
      // 精选主题
      {
        path: 'theme',
        name: 'theme',
        component: () => import('../views/admin/theme/ThemeList.vue'),
        meta: { title: '精选主题' }
      },
      {
        path: 'product_manage',
        name: 'product_manage',
        component: () => import('../views/admin/theme/ProductManage.vue'),
        meta: { title: '精选主题' }
      },

      // 管理员列表
      {
        path: 'users',
        name: 'users',
        component: () => import('../views/admin/users/List.vue'),
        meta: { title: '账号管理' }
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('../views/admin/role/List.vue'),
        meta: { title: '角色管理' }
      },
      
    ],
    beforeEnter(to, from, next) {
      let token = Vue.cookie.get('token');
      if (!token || !/\S/.test(token)) {
        clearLoginInfo();
        next({ name: 'login' })
      }
      next()
    }
  },
  
  {
    path: '/admin/login',
    name: 'login',
    component: () => import('../views/admin/Login.vue'),
    meta: { title: '登录' }
  },



]

